// extracted by mini-css-extract-plugin
module.exports = {"carouselcontainer":"styles_carouselcontainer__3p-mD","imagewrapper":"styles_imagewrapper__1kWOZ","container":"styles_container__2zkdn"};